import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MagnifyingGlass, Crosshair } from "@phosphor-icons/react";

const IOC_TYPES = ["ip", "domain", "url", "hash", "email"];

export default function SocIocs() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [type, setType] = useState("all");

  const load = useCallback(() => {
    const p = new URLSearchParams();
    if (q) p.set("q", q);
    if (type !== "all") p.set("type", type);
    api.get(`/soc/iocs?${p.toString()}`).then(r => setRows(r.data)).catch(() => {});
  }, [q, type]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="p-6 space-y-5" data-testid="soc-iocs-view">
      <div>
        <div className="text-[11px] font-mono uppercase tracking-widest text-rag-red mb-1">Security Operations</div>
        <h1 className="font-display text-3xl font-black flex items-center gap-2"><Crosshair size={26} /> IOC Search</h1>
        <p className="text-sm text-muted-foreground mt-1">Search indicators of compromise across every SOC case.</p>
      </div>

      <Card className="p-3 border-border rounded-sm flex flex-wrap items-center gap-2">
        <div className="relative flex-1 min-w-[220px]">
          <MagnifyingGlass size={14} className="absolute left-2.5 top-2.5 text-muted-foreground" />
          <Input data-testid="soc-ioc-search" value={q} onChange={e => setQ(e.target.value)} placeholder="Search indicator value…" className="rounded-sm h-9 pl-8 text-sm font-mono" />
        </div>
        <Select value={type} onValueChange={setType}>
          <SelectTrigger data-testid="soc-ioc-type-filter" className="w-36 rounded-sm h-9 text-xs"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">All types</SelectItem>{IOC_TYPES.map(t => <SelectItem key={t} value={t}>{t.toUpperCase()}</SelectItem>)}</SelectContent>
        </Select>
      </Card>

      <Card className="border-border rounded-sm overflow-hidden">
        <table className="w-full text-sm" data-testid="soc-iocs-table">
          <thead className="bg-accent/30 text-[10px] font-mono uppercase tracking-widest text-muted-foreground">
            <tr><th className="text-left px-3 py-2.5">Type</th><th className="text-left px-3 py-2.5">Value</th><th className="text-left px-3 py-2.5">Case</th><th className="text-left px-3 py-2.5">Note</th><th className="text-left px-3 py-2.5">Added by</th></tr>
          </thead>
          <tbody>
            {rows.map(io => (
              <tr key={io.id} className="border-t border-border">
                <td className="px-3 py-2.5"><span className="text-[10px] font-mono uppercase px-2 py-0.5 border border-border rounded-sm">{io.type}</span></td>
                <td className="px-3 py-2.5 font-mono">{io.value}</td>
                <td className="px-3 py-2.5"><Link to={`/soc/cases/${io.case_id}`} className="font-mono text-primary hover:underline">{io.case_number}</Link></td>
                <td className="px-3 py-2.5 text-xs text-muted-foreground max-w-[240px] truncate">{io.description}</td>
                <td className="px-3 py-2.5 text-xs">{io.created_by}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="px-3 py-10 text-center text-muted-foreground">No indicators found.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
